jQuery( function ( $ ) {

  let cache = {};


  $( 'section.resource_archive' ).each( function () {

    const $section = $(this);

    const $list = $( 'ul.card-archive', $section );
    const $load_more_btn = $( 'button.load-more', $section );
    const $nav = $( 'nav', $section );
    const posts_per_page = $section.data( 'posts-per-page' );
    const term_filters = $section.data( 'term-filters' );
    let current_page = 1;

    $( '> li', $list ).each( function () {
      cache[ $(this).data( 'id' ) ] = $(this);
    });


    function load_page ( page = 1 ) {
      $load_more_btn.attr( 'disabled', true );
      let $cat_btn = $( 'button[aria-current="true"]', $nav );
      ThemeJS.Functions.wp_rest_request({
        endpoint: 'ph-resource/archive',
        data: {
          paged: page,
          posts_per_page: posts_per_page,
          cached: Object.keys( cache ),
          category: $cat_btn.length ? $cat_btn.data( 'id' ) : null,
          term_filters,
        },
        success ( resp ) {
          if ( page == 1 ) {
            $list.empty();
          }
          resp.posts.forEach( data => {
            if ( data.html ?? null ) {
              cache[ data.id ] = $( data.html );
            }
            $list.append( cache[ data.id ] );
          });
          current_page = page;
          $load_more_btn[ resp.max_page > page ? 'show' : 'hide' ]();
        },
        complete () {
          $load_more_btn.attr( 'disabled', !$load_more_btn.is( ':visible' ) );
        }
      })
    }


    $load_more_btn.on( 'click', function () {
      load_page( current_page + 1 );
    });


    $nav.on( 'click', 'button', function () {
      $( 'button', $nav ).attr( 'aria-current', 'false' );
      $(this).attr( 'aria-current', 'true' );
      load_page( 1 );
    });


    toggle_list_separators();
    $( window ).on( 'breakpoint_changed', toggle_list_separators );
    function toggle_list_separators () {
      let prev_top = 0;
      $( '> div', $nav ).each( function () {
        let this_top = this.getBoundingClientRect().top;
        let is_first = ( this_top > prev_top );
        if ( is_first ) {
          prev_top = this_top;
        }
        $(this).toggleClass( 'first-of-row', is_first );
      });
    }

  });
});